import { render, staticRenderFns } from "./ProvisionalNotesNew.vue?vue&type=template&id=65718e45"
import script from "./ProvisionalNotesNew.vue?vue&type=script&lang=js"
export * from "./ProvisionalNotesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports